import styled, { css } from 'styled-components';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';

export const ContentCell = styled.div`
  vertical-align: middle;
  ${props =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth}px;
    `}

  ${props =>
    !props.noEllipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  text-align: ${props => props.align};
  > * {
    vertical-align: middle;
  }
  b {
    font-weight: bold;
  }
  ${props =>
    props.special &&
    css`
      padding-top: 30px;
      font-size: 14px;
    `};
`;

export const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: '15px 15px',
    height: 'auto'
  },
  body: {
    fontSize: 12,
    padding: '10px 15px',
    height: 'auto'
  }
}))(TableCell);
